// extracted by mini-css-extract-plugin
export var faq__item = "faq-module--faq__item--v0-Td";
export var faq__item_active = "faq-module--faq__item_active--0XeBV";
export var faq__itemAnswer = "faq-module--faq__itemAnswer--ZChiy";
export var faq__itemButton = "faq-module--faq__itemButton--zpRIz";
export var faq__itemTitle = "faq-module--faq__itemTitle--b+xFU";